import React from "react";
import styles from "./Footer.module.scss";
import logoCropped from "../../assets/logoCropped.png";
import { Link } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";

export const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.contactSection}>
        <img src={logoCropped} alt="REIS Logo" className={styles.logo} />
        <h3>Contactanos</h3>
        <a className={styles.linkTxt} href="tel:+9996477998">
          <p>Llamanos : +52 999 647 7998</p>
        </a>
        <p>Asesor Inmobiliario certificado y matriculado.</p>
        <a className={styles.linkTxt} href="mailto:mcsd1969@gmail.com">
          <p>Email: mcsd1969@gmail.com</p>
        </a>
        <div className={styles.socialIcons}>
          <Link to="/contact">
            <FacebookIcon style={{ color: "EFC282" }} />
          </Link>
          <Link to="#">
            <TwitterIcon style={{ color: "EFC282" }} />
          </Link>
          <Link to="#">
            <LinkedInIcon style={{ color: "EFC282" }} />
          </Link>
          <Link to="#">
            <InstagramIcon style={{ color: "EFC282" }} />
          </Link>
        </div>
      </div>
      <div className={styles.linksSection}>
        <div className={styles.features}>
          <h3>Features</h3>
          {featuresLinks.map((link) => (
            <Link key={link.label} to={link.path}>
              {link.label}
            </Link>
          ))}
        </div>
        <div className={styles.company}>
          <h3>Company</h3>
          {companyLinks.map((link) => (
            <Link key={link.label} to={link.path}>
              {link.label}
            </Link>
          ))}
        </div>
        <div className={styles.teamAndPolicies}>
          <h3>Team and policies</h3>
          {teamAndPoliciesLinks.map((link) => (
            <Link key={link.label} to={link.path}>
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

const featuresLinks = [
  { label: "Home", path: "/home" },
  { label: "Become a Host", path: "/become-a-host" },
  { label: "Pricing", path: "/pricing" },
  { label: "Blog", path: "/blog" },
  { label: "Contact", path: "/contact" },
];

const companyLinks = [
  { label: "About Us", path: "/about-us" },
  { label: "Press", path: "/press" },
  { label: "Contact", path: "/contact" },
  { label: "Careers", path: "/careers" },
  { label: "Blog", path: "/blog" },
];

const teamAndPoliciesLinks = [
  { label: "Terms of services", path: "/terms-of-service" },
  { label: "Privacy Policy", path: "/privacy-policy" },
  { label: "Security", path: "/security" },
];
